var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_221_16402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99979 0.888916C6.59334 0.888916 5.21848 1.30598 4.04906 2.08735C2.87965 2.86873 1.9682 3.97934 1.42998 5.27872C0.891753 6.57811 0.750929 8.00792 1.02531 9.38734C1.2997 10.7668 1.97696 12.0338 2.97147 13.0283C3.96598 14.0229 5.23306 14.7001 6.61248 14.9745C7.9919 15.2489 9.42171 15.1081 10.7211 14.5698C12.0205 14.0316 13.1311 13.1202 13.9125 11.9507C14.6938 10.7813 15.1109 9.40647 15.1109 8.00003C15.1109 6.11404 14.3617 4.3053 13.0281 2.97171C11.6945 1.63812 9.88577 0.888916 7.99979 0.888916ZM1.77756 8.00003C1.77799 6.50487 2.31948 5.06037 3.30201 3.93336L12.0665 12.6978C11.1651 13.4762 10.0593 13.9795 8.8803 14.148C7.70134 14.3166 6.49878 14.1432 5.41543 13.6486C4.33207 13.1539 3.41343 12.3588 2.76858 11.3575C2.12374 10.3562 1.77978 9.19097 1.77756 8.00003ZM12.6976 12.0667L3.93312 3.30225C5.12572 2.30577 6.64806 1.79167 8.20062 1.86108C9.75319 1.93049 11.2236 2.5784 12.3225 3.67732C13.4214 4.77624 14.0693 6.24663 14.1387 7.79919C14.2081 9.35175 13.694 10.8741 12.6976 12.0667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_221_16402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletedWhite);
export default __webpack_public_path__ + "static/media/deletedWhite.3a85a448a6aa6a65806895a94f9e7579.svg";
export { ForwardRef as ReactComponent };